import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const ComapnyLables = ({ labels }) => notEmpty(labels) ? (
    <div>
        <DefinitionHeader translate="company.labels" iconType="tags" />
        <ul className="company-labels">
            { labels.split(/\n/).map((labels, index) => (
                <li key={index} className="company-label">
                    {labels}
                </li>
            ))}
        </ul>
    </div>
) : null;

export default ComapnyLables;
